import Container from '@mui/material/Container'

import { PAGE_CONTENT_ID } from './consts'

export type PageContentProps = {
  children: React.ReactNode
}

export const PageContent = ({ children }: PageContentProps) => {
  return (
    <Container
      component="main"
      maxWidth="xl"
      id={PAGE_CONTENT_ID}
      disableGutters // width controls gutters
      tabIndex={-1}
      sx={(_theme) => ({
        width: 'calc(100% - 20px)', // Matching Rails gutters
        minHeight: 'calc(100vh - 180px)', // Magic number to allow some space to show a small bit of the footer
        '&:focus': {
          outline: 'none',
        },
      })}
    >
      {children}
    </Container>
  )
}
